import { DisableableTooltip } from '@components/Tooltips/DisableableTooltip';
import { UserAvatar } from '@components/UserAvatar/UserAvatar';
import { InfoOutlined } from '@mui/icons-material';
import { AutocompleteRenderGetTagProps, Box, Chip } from '@mui/material';
import { PrincipalType } from 'gql/index';
import { useIntl } from 'react-intl';
import { isRemovedPrincipal, removedPrincipalLabelByType } from '.';
import { PrincipalPickerValue } from './PrincipalPicker';
import { useProject } from '@modules/projects/utils/useProject';

interface Props {
  onInviteClicked: () => void;
  getTagProps: AutocompleteRenderGetTagProps;
  principal: PrincipalPickerValue;
  index: number;
  projectId: number;
}

export const PrincipalPickerChip: React.FC<Props> = ({ getTagProps, principal: option, index, onInviteClicked, projectId }) => {
  const { formatMessage } = useIntl();

  const { key: tagKey, ...tagProps } = getTagProps({ index });
  const { canManageProject } = useProject({ projectId });

  if (isRemovedPrincipal(option)) {
    return (
      <Chip
        key={tagKey}
        avatar={(
          <Box color='warning.main'>
            <InfoOutlined sx={{ color: 'warning.main' }} />
          </Box>
        )}
        label={formatMessage(removedPrincipalLabelByType[option.principalType])}
        {...tagProps}
      />
    );
  } else if (typeof option === 'string') {
    return (
      <DisableableTooltip disabled={!canManageProject} arrow disableInteractive title={formatMessage({ id: 'No user was found. You may click to invite this user.' })}>
        <Chip
          key={tagKey}
          clickable={canManageProject}
          onClick={canManageProject ? onInviteClicked : undefined}
          avatar={(
            <Box color='warning.main'>
              <InfoOutlined sx={{ color: 'warning.main' }} />
            </Box>
          )}
          label={option}
          {...tagProps}
        />
      </DisableableTooltip>
    );
  } else if (option.principalType === PrincipalType.User) {
    return (
      <Chip
        key={tagKey}
        avatar={(
          <UserAvatar displayName={option.fullName} />
        )}
        label={option.fullName}
        {...tagProps}
      />
    );
  } else if (option.principalType === PrincipalType.SecurityGroup) {
    return (
      <Chip
        key={tagKey}
        avatar={(
          <UserAvatar displayName={option.name} />
        )}
        label={option.name}
        {...tagProps}
      />
    );
  }
};